import { defineMessages } from "react-intl";

const messages = defineMessages({
    createdBy: {
        id: "test.createdBy",
    },
    noDescription: {
        id: "test.noDescription",
    },
    play: {
        id: "audio.play",
    },
    addAudio: {
        id: "audio.addAudio",
    },
    fileUpload: {
        id: "general.fileUpload",
    },
    fileTooLarge: {
        id: "general.fileTooLarge",
    },
    fileSizeLimit: {
        id: "general.fileSizeLimit",
    },
    close: {
        id: "general.close",
    },
    fileIncorrectFormat: {
        id: "general.fileIncorrectFormat",
    },
    uploadMp3: {
        id: "general.uploadMp3",
    },
});

export default messages;
